import React from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";
// import { createBrowserHistory } from "history";
import Jobs from "../layouts/jobs/Jobs";
import JobsDetail from "../layouts/jobdetail/JobDetail";
import Requisition from "../layouts/requisition/Requisition";
// import RequisitionList from "../layouts/requisition_list/RequisitionList";
import AdminLogin from "../layouts/login/AdminLogin";
import RequisitionList from '../layouts/requisition_list/RequisitionList'
import RequisitionDetail from "../layouts/requisition_detail/RequisitionDetail"
import AdminJobs from "../layouts/admin_job/AdminJobs"
import AdminJobDetail from '../layouts/admin_job/AdminJobDetails'
import CvList from "../layouts/cv/CvList";
import CvDetail from "../layouts/cv_detail/CvDetail";
import CreateJob from "../layouts/admin_job/CreateJob"
import history from "./history";

import {
  ROUTE_JOBS,
  ROUTE_JOB_DETAIL,
  ROUTE_REQUISITION,
  ROUTE_ADMIN,
  ROUTE_ADMIN_LOGIN,
  ROUTE_ADMIN_CV_DETAIL,
  ROUTE_ADMIN_JOB_DETAIL,
  ROUTE_REQUISITION_LIST,
  ROUTE_REQUISITION_DETAIL,
  ROUTE_ADMIN_JOB,
  ROUTE_ADMIN_CV,
  ROUTE_ADMIN_CREATE_JOB
} from "../utils/routes"; 


export const MainRoutes = 
({cookies}) => {
 
  return (
    <Router history={history}>
      <Switch>
        <Route exact={true} path={ROUTE_JOBS} component={Jobs} />
        <Route path={ROUTE_JOB_DETAIL} component={JobsDetail} />
        <Route path={ROUTE_REQUISITION} component={Requisition} />
        <Route path={ROUTE_ADMIN_LOGIN} render={() => (<AdminLogin cookies={cookies}/>)} />
        <Route path={ROUTE_REQUISITION_LIST} component={RequisitionList} cookies={cookies}/>
        <Route path={ROUTE_REQUISITION_DETAIL} component={RequisitionDetail} cookies={cookies}/>
        <Route path={ROUTE_ADMIN_CV} component={CvList} cookies={cookies}/> 
        <Route path={ROUTE_ADMIN_CV_DETAIL} component={CvDetail} cookies={cookies}/>
        <Route path={ROUTE_ADMIN_JOB} component={AdminJobs}/>
        <Route path={ROUTE_ADMIN_JOB_DETAIL} component={AdminJobDetail} />
        <Route path={ROUTE_ADMIN_CREATE_JOB} component = {CreateJob}/>
        <Redirect from={ROUTE_ADMIN} to={ROUTE_ADMIN_LOGIN} />
      </Switch>
    </Router>
  );
};

export default MainRoutes;
